import { render, staticRenderFns } from "./AuthorPreview.vue?vue&type=template&id=1bd5b06b&scoped=true"
import script from "./AuthorPreview.vue?vue&type=script&lang=js"
export * from "./AuthorPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5b06b",
  null
  
)

export default component.exports